/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IParamedic } from 'app/shared/model/paramedic.model';
import { ITenant } from 'app/shared/model/tenant.model';
import { LocationBehavior } from 'app/shared/model/enumerations/location-behavior.model';
import { UniquenessBehavior } from 'app/shared/model/enumerations/uniqueness-behavior.model';

export interface IPatientIdentifierType {
  id?: string;
  name?: string | null;
  uuid?: string | null;
  description?: string | null;
  format?: string | null;
  required?: boolean | null;
  formatDescription?: string | null;
  validator?: string | null;
  locationBehavior?: keyof typeof LocationBehavior | null;
  uniquenessBehavior?: keyof typeof UniquenessBehavior | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number | null;
  active?: boolean | null;
  prefix?: string | null;
  postFix?: string | null;
  prefixYearSno?: boolean;
  doctor?: IDoctor | null;
  paramedic?: IParamedic | null;
  tenant?: ITenant;
}

export const defaultValue: Readonly<IPatientIdentifierType> = {
  required: false,
  active: false,
  prefixYearSno: false,
};
